var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "mb-4 text-xl font-bold" }, [
      _vm._v(" " + _vm._s(_vm.$t("trial.requirementsWindows.title")) + " ")
    ]),
    _c("p", { staticClass: "mb-4 text-xl" }, [
      _vm._v(
        " " + _vm._s(_vm.$t("trial.requirementsWindows.description")) + " "
      )
    ]),
    _c("table", { staticClass: "trial-table border-a mb-4" }, [
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("trial.requirementsWindows.hardware")) + " "
            )
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "border-b pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/certified-devices/windows-devices",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("trial.requirementsWindows.certifiedDevices")
                      )
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/certified-devices/windows-devices/supported-display-types",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.displays")))]
                )
              ])
            ])
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("trial.requirementsWindows.network")) + " "
            )
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "border-b pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/network/ports-and-services",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("trial.requirementsWindows.portsAndServices")
                      )
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/network/fqdn-whitelisting",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("trial.requirementsWindows.whitelisting"))
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("trial.requirementsWindows.wirelessPresentation")
                ) +
                " "
            )
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "border-b pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/presentation/wireless-screen-sharing/mago-link",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.magoLink")))]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/presentation/wireless-screen-sharing/miracast",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.miracast")))]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/presentation/wireless-screen-sharing/airplay",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.airplay")))]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/presentation/wireless-screen-sharing/google-cast",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("trial.requirementsWindows.googleCast"))
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("trial.requirementsWindows.meetingCalendar")) +
                " "
            )
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://kb.mago.io/requirements/calendar",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.calendar")))]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://kb.mago.io/requirements/video-conferencing",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("trial.requirementsWindows.videoConferencing")
                      )
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _c("p", { staticClass: "mb-4 text-xl" }, [
      _vm._v(" " + _vm._s(_vm.$t("trial.requirementsWindows.fullList")) + " "),
      _c(
        "a",
        {
          attrs: { href: "https://kb.mago.io/requirements", target: "_blank" }
        },
        [_vm._v(_vm._s(_vm.$t("trial.requirementsWindows.knowledgeBase")))]
      )
    ]),
    _c(
      "div",
      {
        staticClass: "d-flex justify-end align-center flex-wrap",
        staticStyle: { gap: "8px" }
      },
      [
        _c("va-button", {
          attrs: { type: "outline", cta: _vm.$t("trial.back") },
          on: {
            click: function($event) {
              return _vm.$emit("prev")
            }
          }
        }),
        _c("va-button", {
          attrs: { cta: _vm.$t("trial.verificationComplete") },
          on: {
            click: function($event) {
              return _vm.$emit("next")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }